module.exports = __webpack_public_path__ + "img/recommend_content_1_ug.a395bd46.png";